import React, { useState } from 'react';
import Sidebar from './Sidebar';
import StatusIndicator from './StatusIndicator';
import UserContextPanel from './UserContextPanel';
import NotificationBell from './NotificationBell';

const MainLayout = ({ children }) => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);

  return (
    <div className="min-h-screen bg-background">
      <Sidebar
        isCollapsed={isSidebarCollapsed}
        onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
      />

      <div
        className={`transition-all duration-300 ease-in-out ${
          isSidebarCollapsed ? 'lg:ml-[68px]' : 'lg:ml-[240px]'
        }`}
      >
        {/* Header */}
        <header className="app-header">
          <div className="flex items-center justify-between h-14 px-4 sm:px-6">
            <div className="flex items-center gap-3 ml-12 lg:ml-0">
              <div className="hidden sm:block w-px h-5 bg-border" />
              <h1 className="text-base font-semibold text-foreground" style={{ fontFamily: 'Manrope, sans-serif', letterSpacing: '-0.01em' }}>
                <span className="hidden sm:inline">US Réservation Résidences</span>
                <span className="sm:hidden">USRR</span>
              </h1>
            </div>

            <div className="flex items-center gap-2 sm:gap-3">
              <StatusIndicator />
              <NotificationBell />
              <UserContextPanel />
            </div>
          </div>
        </header>

        {/* Main content */}
        <main className="p-4 sm:p-6 lg:p-8 min-h-[calc(100vh-3.5rem)]">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;